const permissions = {
    //VM PAGE PERMISSIONS
    VM_LISTING: ['VM_LIST'],
    VM_DETAILS: ['VM_GET'],
    VM_BACKUPS: ['VM_BACKUP_GET', 'VM_BACKUP_LIST'],
    VM_CONFIGURATION: ['VM_CONF_GET', 'VM_CONF_UPDATE'],
    VM_POLICY: ['VM_POLICY_ASSIGN', 'VM_POLICY_UNASSIGN', 'POLICY_LIST'],
    VM_BACKUP_START: ['VM_BACKUP_CREATE'],
    VM_BACKUP_EXPIRE: ['VM_BACKUP_EXPIRE'],
    VM_RESTORE: ['VM_RESTORE'],
    VM_FILE_RESTORE: ['VM_RESTORE', 'VM_RESTORE_BROWSE'],

    //CREDENTIALS PERMISSIONS
    VM_CREDENTIALS_ASSIGN: ['VM_CRED_LIST', 'VM_CRED_GET', 'VM_CRED_ASSIGN', 'VM_CRED_UNASSIGN'],
    VM_CREDENTIALS_CREATE: ['VM_CRED_CREATE'],
    VM_CREDENTIALS_UPDATE: ['VM_CRED_UPDATE'],
    VM_CREDENTIALS_DELETE: ['VM_CRED_DELETE'],
    VM_DOWNLOAD_PUBLIC_KEY: ['VM_DOWNLOAD_KEY'],

    //SERVICE PRINCIPALS PERMISSIONS
    SP_LISTING: ['CLOUD_ACCOUNT_LIST', 'CLOUD_ACCOUNT_DEFAULT_GET'],
    SP_DELETE: ['CLOUD_ACCOUNT_DELETE'],
    SP_UPDATE: ['CLOUD_ACCOUNT_UPDATE'],
    SP_CREATE: ['CLOUD_ACCOUNT_ADD'],
    SP_DEFAULT_SET: ['CLOUD_ACCOUNT_DEFAULT_SET'],

    //POLICIES PERMISSIONS
    POLICY_LISTING: ['POLICY_LIST'],
    POLICY_DETAILS: ['POLICY_GET'],
    POLICY_CREATE: ['POLICY_CREATE', 'TARGET_LIST', 'ARCHIVE_LIST', 'BW_LIST'],
    POLICY_UPDATE: ['POLICY_UPDATE', 'TARGET_LIST', 'ARCHIVE_LIST', 'BW_LIST'],
    POLICY_DELETE: ['POLICY_DELETE'],
    DEFAULT_POLICY_SET: ['DEFAULT_POLICY_SET'],

    //ARCHIVES PERMISSIONS
    ARCHIVES_LISTING: ['ARCHIVE_LIST', 'ARCHIVE_GET'],
    ARCHIVE_CREATE: ['ARCHIVE_CREATE'],
    ARCHIVE_UPDATE: ['ARCHIVE_UPDATE'],
    ARCHIVE_DELETE: ['ARCHIVE_DELETE'],

    //BW PERMISSIONS
    BW_LISTING: ['BW_GET', 'BW_LIST'],
    BW_CREATE: ['BW_CREATE'],
    BW_UPDATE: ['BW_UPDATE'],
    BW_DELETE: ['BW_DELETE'],

    //TARGETS PERMISSIONS
    TARGET_LISTING: ['TARGET_LIST'],
    TARGET_DETAILS: ['TARGET_GET'],
    TARGET_ADD: ['TARGET_CREATE'],
    TARGET_UPDATE: ['TARGET_UPDATE'],
    TARGET_DELETE: ['TARGET_DELETE'],
    TARGET_ACTIVATE: ['TARGET_ACTIVATE'],
    TARGET_DEACTIVATE: ['TARGET_DEACTIVATE'],

    //TASKS PERMISSIONS
    TASK_LISTING: ['TASK_LIST'],
    TASK_DETAILS: ['TASK_GET'],
    TASK_REPORT: ['TASK_GET'],
    TASK_ABORT: ['TASK_ABORT'],

    //EVENTS PERMISSIONS 
    EVENT_LISTING: ['EVENT_LIST'],
    EVENT_DETAILS: ['EVENT_GET'],

    //NOTIFICATIONS PERMISSIONS
    EMAIL_NOTIFICATIONS_LISTING: ['EVENT_NTFC_LIST'],
    EMAIL_NOTIFICATIONS_CREATE: ['EVENT_NTFC_CREATE'],
    EMAIL_NOTIFICATIONS_UPDATE: ['EVENT_NTFC_UPDATE'],
    EMAIL_NOTIFICATIONS_DELETE: ['EVENT_NTFC_DELETE'],
    WEBHOOK_NOTIFICATIONS_LISTING: ['WEBHOOK_LIST', 'WEBHOOK_GET'],
    WEBHOOK_NOTIFICATIONS_CREATE: ['WEBHOOK_CREATE'],
    WEBHOOK_NOTIFICATIONS_UPDATE: ['WEBHOOK_UPDATE'],
    WEBHOOK_NOTIFICATIONS_DELETE: ['WEBHOOK_DELETE'],

    //REPORTS PERMISSIONS
    REPORT_LISTING: ['REPORT_LIST'],
    REPORT_DETAILS: ['REPORT_GET'],
    REPORT_CREATE: ['REPORT_CREATE', 'REPORT_TAGS'],
    REPORT_UPDATE: ['REPORT_UPDATE', 'REPORT_TAGS'],
    REPORT_DELETE: ['REPORT_DELETE'],
    REPORT_SCHEDULE: ['RS_GET', 'RS_UPDATE', 'RS_DELETE'],
    REPORT_EXPORT: ['REPORT_EXPORT'],
    REPORT_IMPORT: ['REPORT_IMPORT'],
    REPORT_PREVIEW: ['REPORT_DATA_GET'],
    REPORT_VERSIONS_VIEW: ['RV_GET'],
    REPORT_VERSION_CREATE: ['RV_CREATE'],
    REPORT_VERSION_DELETE: ['RV_DELETE'],
    REPORT_VIEW_EXPORT: ['REPORT_DATA_GET'],

    //USER ROLES
    USER_LISTING: ['ROLE_AUTHORITIES_LIST'],
    ROLE_EDIT: ['ROLE_ASSIGN', 'ROLE_LIST'],
    ROLE_LIST: ['ROLE_LIST'],
    DEFAULT_ROLE_GET: ['ROLE_DEFAULT_ROLE_GET'],
    DEFAULT_ROLE_SET: ['ROLE_DEFAULT_ROLE_SET', 'ROLE_LIST'],
    USER_ACTIVATE: ['USER_ACTIVATE'],
    USER_DEACTIVATE: ['USER_DEACTIVATE'],

    //PROTECTION SETS
    PS_CREATE: ['PS_CREATE'],
    PS_UPDATE: ['PS_UPDATE'],
    PS_DELETE: ['PS_DELETE'],

    //SAAS SUBSCRIPTION INFO ---- AZURE SPECIFIC
    SUB_INFO_GET: ['SUB_INFO_GET'],
    SUB_UPDATE: ['CLOUD_SUB_UPDATE'],
    SUB_UNSUBSCRIBE: ['CLOUD_SUB_DELETE'],

    //EC DEPLOY
    EC_DEPLOY: ['EC_CONTROLLER_DEPLOYMENT']
}

export { permissions };



// WEBPACK FOOTER //
// ./src/azurebackup/constants/permissions.js